import { Directive, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { PortalSettingsService } from 'src/app/core/services/portal-settings.service';

@Directive({
  selector: '[appUSZipFormat]',
  host: {
    '(keyup)': 'validateZipCode($event,true)',
    '(blur)': 'validateZipCode($event,false)'
  }
})
export class USZipFormatDirective {
  portalSetting: any;
  //Read Country code if its value is passed
  @Input('appUSZipFormat') selectedCountryCode: string;
  @Input("value") value: string;
  @Output() valueChange = new EventEmitter<string>();

  constructor(private elementRef: ElementRef<HTMLInputElement>, portalSettingService: PortalSettingsService) {
    this.portalSetting = portalSettingService.getPortalSettings();
  }

  validateZipCode(event: any, type: boolean) {
    if (type) {
      var mask = "";
      var country = (this.selectedCountryCode != '' && this.selectedCountryCode != undefined) ? this.selectedCountryCode : this.portalSetting.CountryDateCode.ConfigValue

      switch (country.toUpperCase()) {
        case "US":
          mask = "99999";
          break;
        case "CAN":
        case "CA":
          mask = "L9L 9L9";
          break;
        case "AU":
          mask = "9999";
          break;
        default:
          mask = "99999";
          break;
      }

      var newVal = event.target.value.replace(/[^a-zA-Z0-9]/gi, '');
      var maskLength = mask.length;
      this.value = "";
      var maskPosition = 0;

      for (var i = 0; i < newVal.length; i++) {
        if (i >= maskLength) {
          break;
        }
        var maskCharacter = mask.charAt(maskPosition);
        if (maskCharacter == "") {
          break;
        }
        while ((maskCharacter != '9') && (maskCharacter != 'L')) {
          this.value += maskCharacter;
          maskPosition++;
          maskCharacter = mask.charAt(maskPosition);
        }
        if (maskCharacter == 'L' && !newVal.charAt(i).match(/[a-zA-Z]/i)) {
          break;
        }
        if (maskCharacter == '9' && !newVal.charAt(i).match(/\d/i)) {
          break;
        }
        this.value += newVal.charAt(i);
        maskPosition++;
      }
      this.elementRef.nativeElement.setAttribute('value', this.value);
      this.valueChange.emit(this.value);
    }
    else {
      var mask = "";
      var country = (this.selectedCountryCode != '' && this.selectedCountryCode != undefined) ? this.selectedCountryCode : this.portalSetting.CountryDateCode.ConfigValue
      switch (country.toUpperCase()) {
        case "US":
          mask = "99999";
          break;
        case "CAN":
        case "CA":
          mask = "L9L 9L9";
          break;
        case "AU":
          mask = "9999";
          break;
        default:
          mask = "99999";
          break;
      }

      if (!mask || mask == "" || mask == undefined) {
        return;
      }
      else {
        var maskLength = mask.length;
        var origVal = event.target.value;
        if (!((origVal.length == maskLength))) {
          this.value = "";
          this.elementRef.nativeElement.setAttribute('value', this.value);
          this.valueChange.emit(this.value);
        }
      }
    }
  }

}
